import Styles from "../editScreenStyles.module.css";
import { yesNoUnsure } from "../../../../constants/options";
import { textToBoolean } from "../../../../utilities/dataUtilities";

function PoliceContactedEdit({
  fields,
  utilities,
  updateClicked,
  cancelClicked
}) {

  const {
    createToggleInput,
    createEditScreenInput
  } = utilities;

  return (
    <div>
      <div className={Styles.title}>Report</div>
      <div className={Styles.column}>
        {createToggleInput(fields.policeAgencyContacted, "100%", yesNoUnsure, true)}
        {textToBoolean(fields.policeAgencyContacted.value) && (
          <div className={Styles.column}>
            <div className={Styles.row}>
              {createEditScreenInput(fields.reportAgencyName, "100%", Styles.input, Styles.blockLabel)}
            </div>
            <div className={Styles.row}>
              {createEditScreenInput(fields.reportNumber, "100%", Styles.input, Styles.blockLabel)}
            </div>
          </div>
        )}

        <div className={Styles.buttons}>
          <button
            type="button"
            className={Styles.button}
            onClick={cancelClicked}
          >
            Cancel
          </button>
          <button
            type="button"
            className={Styles.button}
            onClick={updateClicked}
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
}

export default PoliceContactedEdit;
